module.exports = __webpack_public_path__ + "static/media/emptyAdsImage.b6c71bc2.png";